module.exports = __webpack_public_path__ + "img/zhegnzhou (2).7c4fffa3.png";